import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Top',
    // meta: { layout: 'top' },
    component: () => import('../views/Top.vue'),
  },
  {
    path: '/faq/',
    name: 'FAQ',
    component: () => import('../views/FAQ.vue'),
  },
  {
    path: '/faq/faq_test_吉積情報/',
    name: 'FAQTEST',
    component: () => import('../views/FAQ_TEST.vue'),
  },
  {
    path: '/faq/faq_test_%E5%90%89%E7%A9%8D%E6%83%85%E5%A0%B1/',
    name: 'FAQTEST2',
    component: () => import('../views/FAQ_TEST.vue'),
  },
  {
    path: '/terms/',
    name: 'Terms',
    component: () => import('../views/Terms.vue'),
  },
  {
    path: '/terms-20200923/',
    name: 'Terms-20200923',
    component: () => import('../views/Terms-20200923.vue'),
  },
  {
    path: '/terms-20210817/',
    name: 'Terms-20210817',
    component: () => import('../views/Terms-20210817.vue'),
  },
  {
    path: '/preview',
    name: 'Preview',
    component: () => import('../views/Preview.vue'),
  },
  {
    path: '/:categorySlug/',
    name: 'Posts',
    component: () => import('../views/Posts.vue'),
  },
  {
    path: '/:categorySlug/:postId/',
    name: 'PostDetail',
    component: () => import('../views/PostDetail.vue'),
  },

  // {
  //   path: '/news',
  //   name: 'News',
  //   component: () => import('../views/News.vue'),
  // },
  // {
  //   path: '/news/:postId/',
  //   name: 'NewsDetail',
  //   component: () => import('../views/NewsDetail.vue'),
  // },
  // {
  //   path: '/preview',
  //   name: 'Preview',
  //   component: () => import('../views/Preview.vue'),
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to) {
    if(to.hash){
      // return { selector: to.hash }
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ selector: to.hash })
        }, 200)
      })
    }
    return { x: 0, y: 0 }
  }
})

export default router
